import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import { WagmiProvider, createConfig, http } from "wagmi";
import { polygon, polygonAmoy, bsc, bscTestnet } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { walletConnect, coinbaseWallet } from "wagmi/connectors";

const queryClient = new QueryClient();

const projectId = process.env.REACT_APP_PROJECT_ID;
console.log("projectId:", projectId);

const metadata = {
    name: "Web3Modal",
    description: "Web3Modal Example",
    url: process.env.REACT_APP_ENVIRONMENT === 'production'
        ? process.env.REACT_APP_PROD_APP_URL   // https://beta.magnummeta.xyz
        : process.env.REACT_APP_APP_URL,        // https://alpha-admin.magnummeta.xyz
    icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

const chains = [polygon, polygonAmoy, bsc, bscTestnet];

const config = createConfig({
  chains,
  transports: {
    [polygon.id]: http(),
    [polygonAmoy.id]: http(),
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
  },
  connectors: [
    walletConnect({ projectId, metadata, showQrModal: false }),
    coinbaseWallet({
      appName: metadata.name,
      appLogoUrl: metadata.icons[0],
    }),
  ],
  // projectId,
  // metadata
});

createWeb3Modal({
  projectId,
  wagmiConfig: config,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  // enableOnramp: true, // Optional - false as defaults
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
